import { createSlice } from '@reduxjs/toolkit'

export const embedActivitySlice = createSlice({
    name: 'embedActivity',
    initialState: { 
       managerMessage : {
        state : 'normal', // normal, maximize
        message : '',
        closeButton : ''
       }
    }
    ,reducers : {
        setManagerMessage : (state, action) => {
            state.managerMessage = {
                ...state.managerMessage,
                ...action.payload,
                closeButton : action.payload.closeButton || ''
            };
        }
    }
});

export default embedActivitySlice.reducer;